
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transfer/signal-rules",
      function () {
        return require("private-next-pages/docs/transfer/signal-rules.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transfer/signal-rules"])
      });
    }
  